/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentsRequestEstimateDto } from '../../models/contents-request-estimate-dto';
import { UpdateContentsRequestEstimateDto } from '../../models/update-contents-request-estimate-dto';

export interface ContentsRequestEstimateControllerUpdate$Params {
  id: string;
      body: UpdateContentsRequestEstimateDto
}

export function contentsRequestEstimateControllerUpdate(http: HttpClient, rootUrl: string, params: ContentsRequestEstimateControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestEstimateDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestEstimateControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestEstimateDto>;
    })
  );
}

contentsRequestEstimateControllerUpdate.PATH = '/api/contents-request-estimate/{id}';
